import { makeObservable, observable } from "mobx";
import PagedDataStore, { IFetchListArgs} from "../../../stores/abstract-paged-data-store";
import ShipmentItemStore from "./shipment-item-store";
import { TYPE, rootContainer } from '../../../services/container/root';
import ShipmentsService from "../../../services/api/shipments-service";
import ShipmentListFiltersStore from "./shipments-list-filters-store";
import { IFetchShipmentsListArgs } from "../shipment.types";

class ShipmentsStore extends PagedDataStore<ShipmentItemStore> {
    @observable private _shipmentsListFiltersStore: ShipmentListFiltersStore = new ShipmentListFiltersStore();
    @observable public _isLoaded: boolean = false;

    constructor() {
        super();
        makeObservable(this);
        this._sortBy = 'created_at';
        this._sortDir = 'desc';
    }

    public get shipmentsListFiltersStore(): ShipmentListFiltersStore {
        return this._shipmentsListFiltersStore;
    }
    private get shipmentsService(): ShipmentsService {
        return rootContainer.get<ShipmentsService>(TYPE.ShipmentsService);
    }

    public async fetchList(args: IFetchListArgs) {
        if (this._isLoaded && !this._shipmentsListFiltersStore.hasChanges()) {
            return;
        }
        const filters = this._shipmentsListFiltersStore.getUpdatedModel();
        const shipmentsListArgs: IFetchShipmentsListArgs = { ...args, ...filters } as IFetchShipmentsListArgs;
        const response = await this.shipmentsService.getShipments(shipmentsListArgs);
        const startIndex = (args.page - 1) * args.perPage;
        const endIndex = startIndex + args.perPage;
        const paginatedData = response.data.map(shipment => new ShipmentItemStore(shipment));

        return {
            data: paginatedData,
            current_page: response.current_page,
            per_page: response.per_page,
            total: response.total_records,
            from: startIndex + 1,
            to: endIndex,
            last_page: response.total_pages,
            path: '',
            next_page_url: '',
        };
    }

    public resetIsLoaded() {
        this._isLoaded = false;
    }

    public async load() {
        if (!this._isLoaded) {
            await this.loadPage(this._page);
            return;
        }
        await this.loadPage(this._page);
    }
}

export default new ShipmentsStore();
  